export const PASSWORD_MIN_LENGTH = 8;

const RULES = [
    { test: (p) => p.length >= PASSWORD_MIN_LENGTH, key: 'password_policy_min_length' },
    { test: (p) => /[A-Z]/.test(p), key: 'password_policy_uppercase' },
    { test: (p) => /[a-z]/.test(p), key: 'password_policy_lowercase' },
    { test: (p) => /[0-9]/.test(p), key: 'password_policy_number' },
    { test: (p) => /[^A-Za-z0-9]/.test(p), key: 'password_policy_special' },
];

export function getPasswordPolicyErrors(password) {
    if (!password || typeof password !== 'string') {
        return ['password_policy_min_length'];
    }
    return RULES.filter((rule) => !rule.test(password)).map((rule) => rule.key);
}

export function getPasswordPolicyError(password) {
    const errors = getPasswordPolicyErrors(password);
    return errors.length > 0 ? errors[0] : null;
}

export function isPasswordValid(password) {
    return getPasswordPolicyErrors(password).length === 0;
}

/** Maps API error messages to i18n keys when possible. */
export function mapPasswordApiError(message) {
    if (!message || typeof message !== 'string') {
        return 'try_later';
    }
    const map = {
        'Password is required': 'password_policy_min_length',
        'Password must be at least 8 characters': 'password_policy_min_length',
        'Password must include at least one uppercase letter': 'password_policy_uppercase',
        'Password must include at least one lowercase letter': 'password_policy_lowercase',
        'Password must include at least one number': 'password_policy_number',
        'Password must include at least one special character': 'password_policy_special',
        'Email exist': 'email_exists',
        'invalid_csrf_token': 'invalid_csrf_token',
        'Wrong Credential': 'wrong_credential',
        'Wrong information': 'wrong_credential',
        'account_locked_change_password': 'account_locked_change_password',
        'login_code_invalid': 'login_code_invalid',
        'login_code_sent': 'login_code_sent',
        'email_not_confirmed': 'email_not_confirmed',
        'too_many_registrations': 'too_many_registrations',
        'registration_blocked': 'registration_blocked',
        'captcha_failed': 'captcha_failed',
    };
    return map[message] || message;
}

/** Translates API error strings, including dynamic login attempt warnings. */
export function translateApiError(message) {
    if (!message || typeof message !== 'string') {
        return { key: 'try_later' };
    }
    if (message.startsWith('login_attempts_remaining:')) {
        const count = message.split(':')[1];
        return { key: 'login_attempts_remaining', count: Number(count) || 0 };
    }
    if (message.startsWith('login_code_cooldown:')) {
        const seconds = Number(message.split(':')[1]) || 0;
        const minutes = Math.max(1, Math.ceil(seconds / 60));
        return { key: 'login_code_cooldown', count: minutes };
    }
    return { key: mapPasswordApiError(message) };
}
